import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import "moment/min/locales";
import { API_URL } from "src/scenes/App";
import { formatPhoneNumberIntl, parsePhoneNumber } from "react-phone-number-input";
import {
    LottieLoadingIndicator, Toast, Modal, PortalPageShell,
    PortalLoadingState
} from "src/components";
import MyUserListHeader from "./components/MyUserListHeader";
import UserListsTable from "./components/UserListsTable";
import UserRoleAndPermissionsForm from "./components/UserRoleAndPermissionsForm";
import SendInviteFormModal from "src/components/AppInvite/SendInviteFormModal";
import AddNewUserOptionsModal from "./components/AddNewUserOptionsModal";
import UploadUserListModal from "./components/UploadUserListModal";
import EditUserListModal from "./components/EditUserListModal";
import UserDetailsForm from "./components/UserDetailsForm";
import UserFormSuccessModal from "./components/UserFormSuccessModal";
import UserTagsManagerModal from "./components/UserTagsManagerModal";
import AssignUserTagsModal from "./components/AssignUserTagsModal";
import {
    UserUploadsModal,
} from "./components/UserDocumentsModal";
import { ManageDocumentTypesModal } from "./components/InviteDocuments";
import { getUserListDocumentTypes } from "src/components/Documents/api/documentsApi";
import { getUserTags } from "./api/userTagsApi";

import { AUSTRALIA } from "src/constants/subscriptions";
import { ACCOUNT_OWNER, NO_ROLE } from "src/constants/roles";
import { ACCOUNT_OWNER_PERMISSION } from "src/constants/permissions";
import { UserContext } from "src/scenes/App/UserContext";
import { SubscriptionMode, UserKeys } from "src/constants/userDetails";
import { capitalizeString, setGlobalAccountOwnerEmployeeName } from "src/utils/helpers";
import { getCountryCallingCodeWithPlusSign } from "./components/UploadUserListModal";
import { parseCsvImportErrors } from "./components/csvImportErrors";

export const PageType = {
    EMPLOYEE: 1,
    CLIENT: 2
};

export const SortableColumns = {
    FIRST_NAME: 0,
    LAST_NAME: 1,
    EMAIL: 2,
    MOBILE: 3,
    JOB_TITLE: 4,
    DEPARTMENT: 5,
    USER_STATUS: 6,
};

export const SortableColumnState = {
    INACTIVE: "INACTIVE",
    DESCENDING: "DESCENDING",
    ASCENDING: "ASCENDING",
};

const DirtyState = {
    FALSE: 0,
    TRUE: 1,
    UNKNOWN: 2,
};

class EmployeeList extends Component {
    static contextType = UserContext;
    state = {
        fetching: 0,
        fetchingCsv: 0,
        employeeArray: [],
        uploadUsersArray: [],
        isUserUploadAClient: false,
        companyName: "",
        companyPhoneNumber: "",
        currentSubscription: null,
        companyMode: undefined,
        isCompanyAustralian: false,
        startDate: new Date(),
        subscriptionPeriod: 0,
        totalUsers: 0,
        existedUsers: 0,
        totalEmployees: 0,
        newFirstName: "",
        newLastName: "",
        newTitle: "",
        newDepartment: "",
        newBirthday: "",
        newMobile: "",
        newEmail: "",
        newPermission: false,
        redirect: false,
        isSentSmsInvitation: false,
        isSentEmailInvitation: false,
        errorList: [],
        sortableColumnStates: [],
        dirtyRows: 0,
        countryCallingCode: "",
        isLocaleSet: false,
        showUserPermissionModal: false,
        showUserDetailsFormModal: false,
        showUserFormSuccessModal: false,
        showSendInviteFormModal: false,
        isShowAddNewUserOptions: false,
        isShowUploadUserListModal: false,
        isShowEditUserListModal: false,
        existingUserEmailsResponse: {}, //response from /existingUserEmails route
        permModalData: {
            userUuid: null,
            userName: null,
            role: null,
            permissions: null,
            leadershipRoles: [],
            isBulk: false
        },
        userFormData: {
            formType: "add",
            uuid: null,
            firstName: null,
            lastName: null,
            email: null,
            phoneNumber: null,
            employmentPosition: null,
            department: null,
            isClient: null,
            selectedDocuments: [],
            selectedTags: []
        },
        inviteFormData: {
            users: []
        },
        documentTypes: [],
        userTags: [],
        roles: [],
        showManageDocumentTypesModal: false,
        showUserTagsManagerModal: false,
        showAssignUserTagsModal: false,
        assignUserTagsUsers: [],
        showUserUploadsModal: false,
        selectedDocumentUser: null,
        userNewToken: {},
        userType: PageType.EMPLOYEE,
        customNames: {
            employees: "Employees",
            clients: "Clients"
        },
        isClient: false
    };

    componentDidMount() {
        const { isClient: isClientProp } = this.props;
        const params = new URLSearchParams(location.search);
        const isClientParam = params.get("isClient");
        const isClient =
            isClientParam !== null
                ? isClientParam === "true"
                : Boolean(isClientProp);
        const userType = isClient ? PageType.CLIENT : PageType.EMPLOYEE;

        const currentUser = this.context;
        const customNames = {
            employees: currentUser?.[UserKeys.CUSTOM_NAME_USER_GROUPS_EMPLOYEES] ?? "Employees",
            clients: currentUser?.[UserKeys.CUSTOM_NAME_USER_GROUPS_CLIENTS] ?? "Clients"
        };

        this.getCountryCallingCode();
        this.getCompany();
        this.getRolesAndDefaultPermissions();
        this.fetchDocumentTypes();
        this.fetchUserTags();
        this.setState(state => ({
            fetching: state.fetching + 1,
            userType: userType,
            customNames,
            isClient: isClient
        }), () => this.safeToInit());
        this.setColumns();
    }

    safeToInit = () => {
        setTimeout(() => {
            if (this.state.isLocaleSet) {
                this.getEmployees(this.state.isClient);
                this.setState(state => ({
                    fetching: state.fetching - 1
                }));
            } else {
                this.safeToInit();
            }
        }, 25);
    };

    fetchDocumentTypes = async () => {
        try {
            const res = await getUserListDocumentTypes();
            this.setState({ documentTypes: res.data.documents || [] });
        } catch {
            Toast.error("Unable to fetch document types.");
        }
    };

    fetchUserTags = async () => {
        try {
            const res = await getUserTags(this.props.user.token);
            this.setState({ userTags: res.data.tags || [] });
        } catch {
            Toast.error("Unable to fetch user tags.");
        }
    };

    getRolesAndDefaultPermissions = () => {
        axios.get(`${API_URL}/permissions/roles/get`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.setState({ roles: res.data.roles || [] });
        }).catch(error => {
            Toast.error(error.getApiErrorDetails().message);
        });
    };

    // No need to set state fetching, this function is only setting up the sortable columns array.
    setColumns = () => {
        let columns = [];
        for (let i = 0; i <= SortableColumns.USER_STATUS; i++) {
            columns.push(SortableColumnState.INACTIVE);
        }

        this.setState(state => ({
            sortableColumnStates: columns,
        }));
    };

    getCompany = () => {
        this.setState(state => ({
            fetching: state.fetching + 1
        }));

        axios.get(`${API_URL}/company`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.setState(state => ({
                fetching: state.fetching - 1,
                companyName: res.data.companyName,
                totalEmployees: res.data.totalNumber,
                isCompanyAustralian: res.data.countryCode === AUSTRALIA,
                companyPhoneNumber: res.data.phoneNumber,
                currentSubscription: res.data.currentSubscription,
                companyMode: res.data.mode
            }));
        }).catch(error => {
            return Toast.error(error.getApiErrorDetails().message);
        });
    };

    getSuffix = (isClient) => {

        //detect if it is coming from employee or client
        let suffix;
        if (isClient) {
            suffix = "clients";
        } else {
            suffix = "employees";
        }

        return suffix;
    };


    doesEmployeeHaveError = (employee) => {
        return employee.invalidData != null && Object.keys(employee.invalidData).length > 0;
    };

    /**
     * 3-step process setting a default country code.
     * 1. Asking the API what our calling code should be based on IP.
     * 2. Seeing what country code the company account's phone number has.
     * 3. Assume Australia (+61) if company 'isAustralian' or American (+1) if company is not.
     */
    getCountryCallingCode = () => {
        this.setState(state => ({
            fetching: state.fetching + 1
        }));

        // Getting the country code of the user.
        axios.get(`${API_URL}/callingCode`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            // Step 1 (Get calling code from API)
            let callingCode = res.data.callingCode;

            if (callingCode == null) {
                let phoneNumber = parsePhoneNumber(this.state.companyPhoneNumber);

                // Step 2 (Checking the code of the company phone)
                if (phoneNumber) {
                    callingCode = phoneNumber.countryCallingCode;

                    // Step 3 (Predefined Assumption)
                } else {
                    callingCode = this.state.isCompanyAustralian ? "61" : "1";
                }
            }

            this.setState({
                countryCallingCode: callingCode
            }, () => {
                if (this.state.countryCode) {
                    moment.locale(this.state.countryCode);
                } else {
                    moment.locale(navigator.language);
                }
            });
        }).finally(() => {
            this.setState(state => ({
                fetching: state.fetching - 1,
                isLocaleSet: true,
            }));
        }).catch(error => {
            return Toast.error(error.getApiErrorDetails().message);
        });
    };

    isShowingClients = () => this.state.userType !== PageType.EMPLOYEE;

    getUserRoleId = (user) => user?.role ?? user?.roleAndPermissions?.roleId ?? NO_ROLE;

    syncAccountOwnerEmployeeNameFromUsers = (users) => {
        const currentUserIsAccountOwner = this.context?.[UserKeys.PERMISSIONS]?.includes(ACCOUNT_OWNER_PERMISSION);
        if (!currentUserIsAccountOwner) {
            return;
        }

        const accountOwner = users.find(user => Number(this.getUserRoleId(user)) === ACCOUNT_OWNER);
        if (!accountOwner) {
            return;
        }

        setGlobalAccountOwnerEmployeeName(accountOwner.firstName, accountOwner.lastName);
        this.context.appFns.updateUserContextProperties({});
    };

    updateEmployeeListStates = (isClient, res) => {
        let companyName = res.data.companyName;
        let totalUsers = res.data.totalUsers;
        let existedUsers = res.data.existedUsers;
        //calculate remaining days
        let startDate = res.data.subscriptionStart;
        let subscriptionPeriod = res.data.subscriptionPeriod;
        let users = [];

        if (isClient) {
            let allClients = res.data.clients;

            if (allClients) allClients.forEach(element => {
                let formattedNumber = "";
                if (element.phoneNumber && element.phoneNumber.length > 0) {
                    formattedNumber = formatPhoneNumberIntl(element.phoneNumber);
                }
                element.phoneNumber = formattedNumber.length > 0 ? formattedNumber : element.phoneNumber;
                element.isDirty = DirtyState.FALSE;
                element.invalidData = {};
                if (element.dateOfBirth) {
                    element.dateOfBirth =
                        moment(element.dateOfBirth, ["L", moment.HTML5_FMT.DATE])
                            .format("L");
                }
            });
            users = allClients || [];
        } else {
            let allEmployees = res.data.employees;

            if (allEmployees) allEmployees.forEach(element => {
                let formattedNumber = "";
                if (element.phoneNumber && element.phoneNumber.length > 0) {
                    formattedNumber = formatPhoneNumberIntl(element.phoneNumber);
                }
                element.phoneNumber = formattedNumber.length > 0 ? formattedNumber : element.phoneNumber;
                element.isDirty = DirtyState.FALSE;
                element.invalidData = {};
                if (element.dateOfBirth) {
                    const formatter = Intl.DateTimeFormat("default", { year: "numeric", month: "2-digit", day: "2-digit" });
                    const date = new Date(element.dateOfBirth);
                    element.dateOfBirth = formatter.format(date);
                }
            });
            users = allEmployees || [];
        }

        const sortable = [...this.state.sortableColumnStates];
        sortable[SortableColumns.FIRST_NAME] = SortableColumnState.ASCENDING;
        const sortedUsers = [...users].sort((a, b) => (a.firstName > b.firstName) ? 1 : -1);
        if (!isClient) {
            this.syncAccountOwnerEmployeeNameFromUsers(sortedUsers);
        }

        this.setState({
            companyName: companyName,
            startDate: startDate,
            subscriptionPeriod: subscriptionPeriod,
            totalUsers: totalUsers,
            existedUsers: existedUsers,
            employeeArray: sortedUsers,
            sortableColumnStates: sortable,
            userType: isClient ? PageType.CLIENT : PageType.EMPLOYEE
        });
    };

    getEmployees = (isClient) => {
        this.setState(state => ({
            fetching: state.fetching + 1,
            employeeArray: [],
            dirtyRows: 0
        }));

        const suffix = this.getSuffix(isClient);
        axios.get(`${API_URL}/${suffix}`, {
            headers: {
                Authorization: "Bearer " + this.props.user.token
            }
        }).then(res => {
            this.updateEmployeeListStates(isClient, res);
        }).finally(() => {
            this.setState(state => ({
                fetching: state.fetching - 1,
            }));
        }).catch(error => {
            return Toast.error(error.getApiErrorDetails().message);
        });
    };

    postEmployee = async (user, isClient) => {
        const jsonArray = JSON.parse(JSON.stringify([user]));
        const suffix = isClient ? "clients" : "employees";

        this.setState(prevState => ({
            errorList: []
        }));

        try {
            const res = await axios.post(
                `${API_URL}/${suffix}`,
                jsonArray,
                {
                    headers: {
                        Authorization: `Bearer ${this.props.user.token}`,
                    },
                }
            );

            const responseUsers = isClient ? res.data.clients : res.data.employees;
            if (responseUsers.length !== 1) {
                this.setState({
                    errorList: ["Something went wrong during user creation."],
                });
                return;
            }

            const employeeUuid = responseUsers[0].uuid;
            this.getEmployees(isClient);
            this.setState(prevState => ({
                userFormData: {
                    ...prevState.userFormData,
                    uuid: employeeUuid,
                },
                showUserDetailsFormModal: false,
                showUserFormSuccessModal: true,
            }));

        } catch (error) {
            this.postAndPatchErrorCallBack(error);
            throw error; // Re-throw the error to be caught by the caller
        }
    };

    patchEmployee = async (user, sourceUser) => {
        const suffix = user.isClient ? "clients" : "employees";
        this.setState({
            errorList: [],
        });

        try {
            await axios.put(`${API_URL}/${suffix}/${user.uuid}`, user, {
                headers: {
                    Authorization: "Bearer " + this.props.user.token
                }
            });

            Toast.success("User updated successfully");
            this.syncCurrentUserName(sourceUser);
            this.getEmployees(user.isClient);
            await this.fetchDocumentTypes();
            this.setState({
                showUserDetailsFormModal: false
            });
        } catch (error) {
            this.postAndPatchErrorCallBack(error);
        }
    };

    syncCurrentUserName = (user) => {
        if (!user) {
            return;
        }

        if (this.context?.[UserKeys.UUID] === user.uuid) {
            this.context.appFns.updateUserContextProperties({
                [UserKeys.FIRST_NAME]: user.firstName,
                [UserKeys.LAST_NAME]: user.lastName
            });
            return;
        }

        const currentUserIsAccountOwner = this.context?.[UserKeys.PERMISSIONS]?.includes(ACCOUNT_OWNER_PERMISSION);
        if (!currentUserIsAccountOwner || Number(this.getUserRoleId(user)) !== ACCOUNT_OWNER) {
            return;
        }

        setGlobalAccountOwnerEmployeeName(user.firstName, user.lastName);
        this.context.appFns.updateUserContextProperties({});
    };

    updateUserType = async (userUuid, currentIsClient, nextIsClient) => {
        const suffix = currentIsClient ? "clients" : "employees";
        this.setState({
            errorList: [],
        });

        try {
            await axios.put(`${API_URL}/${suffix}/${userUuid}/userType`, {
                isClient: nextIsClient,
            }, {
                headers: {
                    Authorization: "Bearer " + this.props.user.token
                }
            });

            Toast.success("User type updated successfully");
            this.getEmployees(nextIsClient);
            this.setState({
                showUserDetailsFormModal: false
            });
        } catch (error) {
            this.postAndPatchErrorCallBack(error);
        }
    };

    uploadCsvPostEmployees = (data, suffix, modalSetErrorList, modalClose) => {
        let jsonArray = JSON.parse(JSON.stringify(data));

        modalSetErrorList([]);
        this.setState({
            fetchingCsv: this.state.fetchingCsv + 1
        });

        axios.post(`${API_URL}/${suffix}/csv`,
            jsonArray,
            {
                headers: {
                    Authorization: "Bearer " + this.props.user.token
                }
            })
            .then(res => {
                modalClose();
                this.getEmployees(suffix === "clients");
                Toast.success("Import Successful");
            }).catch(error => {
                // Refresh the list because some valid users may already have been inserted.
                this.getEmployees(suffix === "clients");
                this.uploadCsvPostEmployeesErrorCallBack(error, modalSetErrorList);
            }).finally(error => {
                this.setState({
                    fetchingCsv: this.state.fetchingCsv - 1,
                });
            });
    };

    uploadCsvPostEmployeesErrorCallBack(error, modalSetErrorList) {
        const details = error.getApiErrorDetails();
        if (details.message === "Please add more users") {
            this.handleCloseEditUserListModal();
            this.showSubscriptionCapReachedModal();
            return;
        }

        const csvImportErrors = parseCsvImportErrors(error.data);
        if (csvImportErrors) {
            modalSetErrorList(csvImportErrors);
            return;
        }

        modalSetErrorList(error.getApiErrorMessages());
    }

    postAndPatchErrorCallBack(error) {
        const details = error.getApiErrorDetails();
        if (details.message === "Please add more users") {
            this.handleCloseUserDetailsFormModal();
            this.showSubscriptionCapReachedModal();
            return;
        }

        this.setState({
            errorList: error.getApiErrorMessages()
        });
    }

    showSubscriptionCapReachedModal() {
        //display cap reached coz we reached the cap
        return Modal.open(
            "Subscription Cap Reached",
            <div>
                <p>You have used up all available subscriptions. You will need to purchase more in
                    order to add new clients/employees. Alternatively, you can remove an existing
                    user to free up a slot -- however, this does mean that user will no longer be
                    able to use the Me app.</p>
                <p>To add more users simply click <strong>Active Subscriptions</strong> in
                    the navigation panel, or click the button below, and purchase
                    more subscriptions.
                </p>
            </div>,
            () => window.location.href = "/active",
            "Purchase More Users",
            false
        );
    }

    updateEmployee = async (user) => {
        this.setState({
            userFormData: {
                formType: "edit",
                uuid: user.uuid,
                firstName: user.firstName,
                lastName: user.lastName,
                isClient: user.isClient,
                phoneNumber: user.phoneNumber,
                department: user.department,
                employmentPosition: user.employmentPosition,
                email: user.email,
                selectedTags: user.selectedTags || []
            }
        });

        const { newEmployee, errorList } = this.newUser(user, false);
        if (errorList.length === 0) {
            return await this.patchEmployee(newEmployee, {
                ...user,
                firstName: newEmployee.firstName,
                lastName: newEmployee.lastName
            });
        } else {
            this.setState({
                errorList: errorList,
            });
            // Optionally, you might want to return something here to indicate failure
            return Promise.reject(new Error("Validation errors occurred."));
        }
    };

    newUser = (user, isNewUser) => { // both patchEmployee and postEmployees depend on this
        const isClient = user.isClient;
        let errorList = [];
        let newEmployee = {};
        newEmployee["newUser"] = isNewUser;
        newEmployee["isClient"] = isClient;
        newEmployee["firstName"] = user.firstName ? capitalizeString(user.firstName) : null;
        newEmployee["lastName"] = user.lastName ? capitalizeString(user.lastName) : null;
        newEmployee["email"] = user.email;
        newEmployee["phoneNumber"] = user.phoneNumber !== null && user.phoneNumber !== undefined ? user.phoneNumber.replace(/\s+/g, "") : null;

        if (newEmployee["phoneNumber"]) {
            newEmployee["phoneNumber"] = this.autoRemoveCountryCodeOnSubmit(newEmployee["phoneNumber"], this.context[UserKeys.COUNTRY_CODE]);
        }

        newEmployee["employmentPosition"] = user.employmentPosition;
        newEmployee["selectedDocuments"] = user.selectedDocuments || [];
        newEmployee["selectedTags"] = user.selectedTags || [];

        if (!isClient) {
            newEmployee["department"] = user.department;
        }

        if (!isNewUser) {
            newEmployee["uuid"] = user.uuid;
        }

        return { newEmployee, errorList };
    };

    removeCountryCodePrefix(phoneValue, countryCodeToRemove) {
        if (!phoneValue || !countryCodeToRemove) {
            return phoneValue; // Handle empty inputs
        }

        if (phoneValue.length !== countryCodeToRemove.length) { //we only remove autoAssigned country code
            return phoneValue;
        }

        if (phoneValue.startsWith(countryCodeToRemove)) {
            return phoneValue.slice(countryCodeToRemove.length);
        }

        return phoneValue; // String doesn't start with partToRemove, return original
    }

    autoRemoveCountryCodeOnSubmit(phoneValue, defaultCountry) {
        const countryCode = getCountryCallingCodeWithPlusSign(defaultCountry);
        const phoneTest = this.removeCountryCodePrefix(phoneValue, countryCode);

        return phoneTest;
    }

    saveNew = async (user) => {
        this.setState({
            userFormData: {
                formType: "add",
                firstName: user.firstName,
                lastName: user.lastName,
                isClient: user.isClient,
                phoneNumber: user.phoneNumber,
                department: user.department,
                employmentPosition: user.employmentPosition,
                email: user.email,
                selectedTags: user.selectedTags || []
            }
        });

        const { newEmployee, errorList } = this.newUser(user, true);

        if (errorList.length > 0) {
            this.setState({ errorList });
            return;
        }

        await this.postEmployee(newEmployee, user.isClient);
    };

    sortColumns = (columnIndex) => {
        if (typeof columnIndex === "undefined") {
            return;
        }

        const columns = this.state.sortableColumnStates;
        let fieldName = "";

        // Setting all other column values to inactive, this way they will always start as descending when clicked after another column,
        // while any subsequent clicks will toggle between descending and ascending sort.
        for (let i = 0; i <= SortableColumns.USER_STATUS; i++) {
            if (i === columnIndex) {
                let value = columns[columnIndex];

                switch (value) {
                    case SortableColumnState.DESCENDING:
                        value = SortableColumnState.ASCENDING;
                        break;
                    case SortableColumnState.ASCENDING:
                        value = SortableColumnState.DESCENDING;
                        break;
                    case SortableColumnState.INACTIVE:
                    default:
                        value = SortableColumnState.ASCENDING;
                        break;
                }

                columns[columnIndex] = value;
            } else {
                columns[i] = SortableColumnState.INACTIVE;
            }
        }

        // Calling the sort for the particular column affected.
        switch (columnIndex) {
            case SortableColumns.FIRST_NAME:
                fieldName = "firstName";
                break;
            case SortableColumns.LAST_NAME:
                fieldName = "lastName";
                break;
            case SortableColumns.EMAIL:
                fieldName = "email";
                break;
            case SortableColumns.MOBILE:
                fieldName = "phoneNumber";
                break;
            case SortableColumns.JOB_TITLE:
                fieldName = "employmentPosition";
                break;
            case SortableColumns.DEPARTMENT:
                fieldName = "department";
                break;
            case SortableColumns.USER_STATUS:
            default:
                this.sortStatus(columns[columnIndex]);
                break;
        }

        if (fieldName !== "")
            this.sortField(columns[columnIndex], fieldName);

        this.setState({
            sortableColumnStates: columns
        });
    };

    sortField = (sortableState, fieldName) => {
        const employees = this.state.employeeArray;

        if (sortableState === SortableColumnState.ASCENDING) {
            employees.sort((a, b) => (a[fieldName] > b[fieldName]) ? 1 : -1);
        } else {
            employees.sort((a, b) => (a[fieldName] < b[fieldName]) ? 1 : -1);
        }

        this.setState({
            employeeArray: employees
        });
    };

    sortStatus = (sortableState) => {
        const employees = this.state.employeeArray;

        if (sortableState === SortableColumnState.ASCENDING) {
            employees.sort((a, b) => {
                let aStatus = a.status ? "ACTIVE" : (a.hasReceivedInvitation ? "AWAITING INVITATION" : this.doesEmployeeHaveError(a) ? "ERROR" : "PENDING");
                let bStatus = b.status ? "ACTIVE" : (b.hasReceivedInvitation ? "AWAITING INVITATION" : this.doesEmployeeHaveError(b) ? "ERROR" : "PENDING");
                return (aStatus > bStatus) ? 1 : -1;
            });
        } else {
            employees.sort((a, b) => {
                let aStatus = a.status ? "ACTIVE" : (a.hasReceivedInvitation ? "AWAITING INVITATION" : this.doesEmployeeHaveError(a) ? "ERROR" : "PENDING");
                let bStatus = b.status ? "ACTIVE" : (b.hasReceivedInvitation ? "AWAITING INVITATION" : this.doesEmployeeHaveError(b) ? "ERROR" : "PENDING");
                return (aStatus < bStatus) ? 1 : -1;
            });
        }

        this.setState({
            employeeArray: employees
        });
    };

    setUploadUsers = (uploadUsersArray) => {
        this.setState(state => ({
            uploadUsersArray: uploadUsersArray
        }));
    };

    setIsUserUploadAClient = (bool) => {
        this.setState(state => ({
            isUserUploadAClient: bool
        }));
    };

    openUserPermissionModal = (data) => {
        this.setState({ showUserPermissionModal: true });
        this.setState({
            permModalData: {
                userUuid: data.uuid,
                userName: data.name,
                userEmail: data.email,
                isClient: data.isClient,
                role: data.role ? data.role : NO_ROLE,
                permissions: data.permissions ? data.permissions : [],
                leadershipRoles: data.leadershipRoles
            }
        });
    };

    openUserDetailsForm = (data) => {
        const isClient = this.isShowingClients();

        this.setState({
            userFormData: {
                formType: data ? "edit" : "add",
                uuid: data ? data.uuid : "",
                firstName: data ? data.firstName : "",
                lastName: data ? data.lastName : "",
                email: data ? data.email : "",
                isClient: data ? data.isClient : isClient,
                phoneNumber: data ? data.phoneNumber : "",
                employmentPosition: data && data.employmentPosition !== null ? data.employmentPosition : "",
                department: data && data.department !== null ? data.department : "",
                selectedDocuments: data?.requiredDocuments?.map(document => document.uuid) || [],
                selectedTags: data?.userTags?.map(tag => tag.uuid) || [],
                userTags: data?.userTags || []
            }
        }, () => this.setState({ showUserDetailsFormModal: true }));
    };

    openAddNewUserOptions = () => {
        this.setState({ isShowAddNewUserOptions: true });
    };

    openUploadUserListModal = () => {
        this.setState({ isShowUploadUserListModal: true });
    };

    openEditUserListModal = (existingUserEmailsResponse) => {
        this.setState({ isShowEditUserListModal: true, existingUserEmailsResponse: existingUserEmailsResponse });
    };

    openSendInviteForm = (data) => {
        this.handleCloseUserFormSuccessModal();
        this.setState({
            inviteFormData: {
                users: data
            },
            showSendInviteFormModal: true
        });
    };

    openManageDocumentTypesModal = () => {
        this.setState({ showManageDocumentTypesModal: true });
    };

    openUserTagsManagerModal = () => {
        this.setState({ showUserTagsManagerModal: true });
    };

    openAssignUserTagsModal = (users) => {
        this.setState({
            assignUserTagsUsers: users,
            showAssignUserTagsModal: true
        });
    };

    openBulkPermissionsModal = () => {
        const isClient = this.isShowingClients();

        this.setState({
            showUserPermissionModal: true,
            permModalData: {
                userUuid: null,
                userName: null,
                userEmail: null,
                isClient,
                role: NO_ROLE,
                permissions: [],
                leadershipRoles: [],
                isBulk: true
            }
        });
    };

    openUserUploadsModal = (user) => {
        this.setState({
            selectedDocumentUser: user,
            showUserUploadsModal: true
        });
    };

    handleRemoveSelectedUsers = async (users, fromModal = false) => {
        if (!window.confirm("Are you sure you want to delete selected user(s)?")) {
            return;
        }

        const isClient = this.isShowingClients();
        const suffix = this.getSuffix(isClient);

        if (!fromModal) {
            this.setState(prevState => ({
                fetching: prevState.fetching + 1,
            }));
        }

        try {
            await axios.post(
                `${API_URL}/${suffix}/deleteUsers/`,
                { uuids: users },
                {
                    headers: {
                        Authorization: `Bearer ${this.props.user.token}`,
                    },
                }
            );

            if (!fromModal) {
                this.setState(prevState => ({
                    fetching: prevState.fetching - 1,
                    showUserDetailsFormModal: false,
                }));
            }

            this.getEmployees(isClient);
            Toast.success("User(s) deleted successfully");
        } catch (error) {

            if (!fromModal) {
                this.setState(prevState => ({
                    fetching: prevState.fetching - 1,
                }));
            }
            Toast.error(error.getApiErrorDetails().message);
        }
    };

    showAccessTokenModal = (email, uuid) => {
        let data = {
            "email": email,
            "uuid": uuid
        };

        this.setState({
            showAccessTokenModal: true,
            userNewToken: data
        });
    };

    handleClosePermissionFormModal = () => {
        this.setState({
            showUserPermissionModal: false,
            permModalData: {
                userUuid: null,
                userName: null,
                userEmail: null,
                role: null,
                permissions: null,
                leadershipRoles: [],
                isBulk: false
            }
        });
    };

    handleCloseUserDetailsFormModal = () => {
        this.setState({ showUserDetailsFormModal: false, errorList: [] });
    };

    handleCloseUserFormSuccessModal = () => {
        this.setState({
            showUserFormSuccessModal: false,
            userFormData: {
                formType: "add",
                uuid: null,
                firstName: null,
                lastName: null,
                email: null,
                phoneNumber: null,
                employmentPosition: null,
                department: null,
                isClient: null,
                selectedTags: []
            }
        });
    };

    handleCloseInviteFormModal = reload => {
        this.setState({ showSendInviteFormModal: false });
        if (reload) {
            const isClient = this.isShowingClients();
            this.getEmployees(isClient);
        }
    };

    handleCloseNewUserOptionsModal = () => {
        this.setState({ isShowAddNewUserOptions: false });
    };

    handleCloseUploadUserListModal = () => {
        this.setState({ isShowUploadUserListModal: false });
    };

    handleCloseEditUserListModal = () => {
        this.setState({ isShowEditUserListModal: false });
    };

    formSubmissionSuccessful = () => {
        const isClient = this.isShowingClients();
        this.getEmployees(isClient);
        this.handleClosePermissionFormModal();
    };

    onFilterChange = (e) => {
        const isClient = parseInt(e.target.value) === PageType.CLIENT;
        this.getEmployees(isClient);
        this.setState({
            userType: isClient,
            isUserUploadAClient: isClient
        });
    };

    onBulkPermissionUserTypeChange = (isClient) => {
        this.getEmployees(isClient);
        this.setState(prevState => ({
            permModalData: {
                ...prevState.permModalData,
                isClient,
                role: NO_ROLE,
                permissions: [],
                leadershipRoles: [],
                isBulk: true
            }
        }));
    };

    setCustomNames = (newNames) => {
        this.setState({ customNames: newNames });
    };

    render() {
        const isClient = this.isShowingClients();

        const { fetching, fetchingCsv, employeeArray, uploadUsersArray, totalUsers, existedUsers, errorList, startDate, subscriptionPeriod,
            showUserPermissionModal, permModalData, showUserDetailsFormModal, userFormData, customNames, roles,
            showUserFormSuccessModal, isUserUploadAClient, currentSubscription, companyMode,
            showSendInviteFormModal, inviteFormData, isShowAddNewUserOptions, isShowUploadUserListModal, isShowEditUserListModal, existingUserEmailsResponse,
            sortableColumnStates, documentTypes, userTags, showManageDocumentTypesModal, showUserTagsManagerModal,
            showAssignUserTagsModal, assignUserTagsUsers, showUserUploadsModal, selectedDocumentUser,

        } = this.state;

        const isSubscriptionCapReached = companyMode !== SubscriptionMode.DEMO && (totalUsers - existedUsers) < 1;

        return (
            <PortalPageShell>
                <MyUserListHeader
                    fetching={fetching}
                    existedUsers={existedUsers}
                    totalUsers={totalUsers}
                    customNames={customNames}
                    setCustomNames={this.setCustomNames}
                    documentTypes={documentTypes}
                    userTags={userTags}
                    openManageDocumentTypesModal={this.openManageDocumentTypesModal}
                    openUserTagsManagerModal={this.openUserTagsManagerModal}
                    openBulkPermissionsModal={this.openBulkPermissionsModal}
                />

                <PageLoadingContainer isFetching={fetching > 0} >
                    <UserListsTable
                        users={employeeArray}
                        isShowingClients={isClient}
                        startDate={startDate}
                        subscriptionPeriod={subscriptionPeriod}
                        openPermissionForm={this.openUserPermissionModal}
                        openUserDetailsForm={this.openUserDetailsForm}
                        openAddNewUserOptions={this.openAddNewUserOptions}
                        sortColumn={(key) => this.sortColumns(SortableColumns[key])}
                        sortableColumnStates={sortableColumnStates}
                        removeUsers={async (users) => await this.handleRemoveSelectedUsers(users, false)}
                        openSendInviteForm={(data) => this.openSendInviteForm(data)}
                        fetching={fetching}
                        customNames={customNames}
                        currentSubscription={currentSubscription}
                        roles={roles}
                        onFilterChange={(e) => this.onFilterChange(e)}
                        existedUsers={existedUsers}
                        openUserUploadsModal={this.openUserUploadsModal}
                        openAssignUserTagsModal={this.openAssignUserTagsModal}
                    />
                </PageLoadingContainer>


                {isShowAddNewUserOptions &&
                    <AddNewUserOptionsModal
                        showDialog={isShowAddNewUserOptions}
                        showSubscriptionCapReachedModal={this.showSubscriptionCapReachedModal}
                        openUserDetailsForm={this.openUserDetailsForm}
                        openUploadUserListModal={this.openUploadUserListModal}
                        handleClose={this.handleCloseNewUserOptionsModal}
                        isSubscriptionCapReached={isSubscriptionCapReached}
                        customNames={customNames}
                    />
                }

                {isShowUploadUserListModal &&
                    <UploadUserListModal
                        showDialog={isShowUploadUserListModal}
                        handleClose={this.handleCloseUploadUserListModal}
                        setUploadUsers={this.setUploadUsers}
                        openEditUserListModal={this.openEditUserListModal}
                        isClient={isClient}
                        setIsClient={this.setIsUserUploadAClient}
                        countryCode={this.context[UserKeys.COUNTRY_CODE]}
                        token={this.props.user.token}
                        customNames={customNames}
                    />
                }

                {isShowEditUserListModal &&
                    <EditUserListModal
                        showDialog={isShowEditUserListModal}
                        handleClose={this.handleCloseEditUserListModal}
                        openUploadUserListModal={this.openUploadUserListModal}
                        uploadUsers={uploadUsersArray}
                        isClient={isUserUploadAClient}
                        uploadCsvPostEmployees={this.uploadCsvPostEmployees}
                        newUser={this.newUser}
                        token={this.props.user.token}
                        fetchingCsv={fetchingCsv}
                        countryCode={this.context[UserKeys.COUNTRY_CODE]}
                        existingUserEmailsResponse={existingUserEmailsResponse}
                        customNames={customNames}
                        companyMode={companyMode}
                    />
                }

                {showUserPermissionModal && <>
                    <UserRoleAndPermissionsForm
                        user={this.props.user}
                        showDialog={showUserPermissionModal}
                        handleClose={() => this.handleClosePermissionFormModal()}
                        onFormSubmissionSuccessful={() => this.formSubmissionSuccessful()}
                        userUuid={permModalData.userUuid}
                        userName={permModalData.userName}
                        userEmail={permModalData.userEmail}
                        userRole={permModalData.role}
                        userPermissions={permModalData.permissions}
                        roles={roles}
                        token={this.props.user.token}
                        isClient={permModalData.isClient}
                        isBulk={permModalData.isBulk}
                        users={employeeArray}
                        customNames={customNames}
                        onBulkUserTypeChange={this.onBulkPermissionUserTypeChange}
                        hasLeadershipRole={permModalData.leadershipRoles.length > 0}
                    />
                </>}

                {showUserDetailsFormModal && <>

                    <UserDetailsForm
                        showDialog={showUserDetailsFormModal}
                        handleClose={() => this.handleCloseUserDetailsFormModal()}
                        user={userFormData}
                        token={this.props.user.token}
                        createNewUser={async (data) => await this.saveNew(data)}
                        removeUsers={async (users) => await this.handleRemoveSelectedUsers(users, true)}
                        updateEmployee={async (user) => await this.updateEmployee(user)}
                        updateUserType={async (userUuid, currentIsClient, nextIsClient) =>
                            await this.updateUserType(userUuid, currentIsClient, nextIsClient)
                        }
                        errorList={errorList}
                        countryCode={this.context[UserKeys.COUNTRY_CODE]}
                        customNames={customNames}
                        documentTypes={documentTypes}
                        userTags={userTags}
                    />
                </>}
                {showUserFormSuccessModal && <>
                    <UserFormSuccessModal
                        showDialog={showUserFormSuccessModal}
                        handleClose={() => this.handleCloseUserFormSuccessModal()}
                        user={userFormData}
                        openSendInviteForm={this.openSendInviteForm}
                        isUserNewlyCreated={this.state.userFormData.formType === "add"}
                        customNames={customNames}
                    />
                </>
                }
                {showSendInviteFormModal && <>
                    <SendInviteFormModal
                        showDialog={showSendInviteFormModal}
                        handleClose={reload => this.handleCloseInviteFormModal(reload)}
                        users={inviteFormData.users}
                        token={this.props.user.token}
                        documentTypes={documentTypes}
                        onDocumentsSaved={() => {
                            this.getEmployees(isClient);
                        }}
                    />
                </>}
                {showManageDocumentTypesModal && (
                    <ManageDocumentTypesModal
                        open={showManageDocumentTypesModal}
                        onClose={() => this.setState({ showManageDocumentTypesModal: false })}
                        documentTypes={documentTypes}
                        refresh={this.fetchDocumentTypes}
                    />
                )}

                {showUserTagsManagerModal && (
                    <UserTagsManagerModal
                        open={showUserTagsManagerModal}
                        onClose={() => this.setState({ showUserTagsManagerModal: false })}
                        token={this.props.user.token}
                        tags={userTags}
                        onChanged={async () => {
                            await this.fetchUserTags();
                            this.getEmployees(this.isShowingClients());
                        }}
                    />
                )}

                {showAssignUserTagsModal && (
                    <AssignUserTagsModal
                        open={showAssignUserTagsModal}
                        onClose={() => this.setState({ showAssignUserTagsModal: false, assignUserTagsUsers: [] })}
                        token={this.props.user.token}
                        users={assignUserTagsUsers}
                        tags={userTags}
                        customNames={customNames}
                        onSaved={async () => {
                            await this.fetchUserTags();
                            this.getEmployees(this.isShowingClients());
                        }}
                    />
                )}

                {showUserUploadsModal && selectedDocumentUser && (
                    <UserUploadsModal
                        open={showUserUploadsModal}
                        onClose={() => this.setState({ showUserUploadsModal: false })}
                        user={selectedDocumentUser}
                        onSaved={() => {
                            console.log("onSaved fired");
                            this.getEmployees(this.isShowingClients());
                        }}
                    />
                )}
            </PortalPageShell>
        );
    }
}

const PageLoadingContainer = ({ children, isFetching }) => {
    return (
        <>
            {
                isFetching && <PortalLoadingState minHeight="40rem">
                    <LottieLoadingIndicator />
                </PortalLoadingState>
            }
            {!isFetching && children}
        </>
    );
};

export default withRouter(EmployeeList);
